"use client";  // Asegúrate de usar 'use client' ya que estamos manejando lógica de estado aquí.
import React from 'react';

const Dropdown = () => {
  return (
    <div className="relative">
    
  <div className="absolute right-0 top-16 bg-gray-100 dark:bg-neutral-950 shadow-lg w-72 rounded-lg z-50">
    <ul className="py-2 text-white font-sans divide-y divide-neutral">
      <li className="flex items-center px-4 py-3 dark:hover:bg-gray-700 hover:bg-gray-200 rounded-md">
        <a
          href="/"
          className="block text-neutral-950 md:hidden dark:text-blue-100 font-medium"
        >
          Home 
        </a>
      </li>
      <li className="flex items-center px-4 py-3 dark:hover:bg-gray-700 hover:bg-gray-200 rounded-md">
        <a
          href="/blog"
          className="block text-neutral-950 md:hidden dark:text-blue-100 font-medium"
        >
          Blog 
        </a>
      </li>
      <li className="flex items-center px-4 py-3 dark:hover:bg-gray-700 hover:bg-gray-200 rounded-md">
        <a
          href="/projects"
          className="block text-neutral-950 dark:text-blue-100 font-medium"
        >
          Projects 
        </a>
      </li>
      <li className="flex items-center px-4 py-3 dark:hover:bg-gray-700 hover:bg-gray-200 rounded-md">
        <a
          href="/aboutme"
          className="block text-neutral-950 dark:text-blue-100 font-medium"
        >
          About 
        </a>
      </li>
      <li className="flex items-center px-4 py-3 dark:hover:bg-gray-700 hover:bg-gray-200 rounded-md">
        <a
          href="/404"
          className="block text-neutral-950 dark:text-blue-100 font-medium"
        >
          Error Page 
        </a>
      </li>
    </ul>
  </div>


    </div>
  );
};

export default Dropdown;

